import {useCallback} from "react";
import {useGetEndDateForNonLinearPlan} from "../../../../../../../apis/requests/plans";
import {PaymentPlanFrequency} from "@bounce/shared/enums";
import dayjs from "dayjs";
import {DATE_FORMAT, multiply} from "@bounce/shared/helpers";
import {divide} from "lodash";

interface UseGetEndDateProps {
  accountId: string;
  startDate: string;
  frequency: PaymentPlanFrequency;
  numberOfInstallments: number;
  installmentSize: number;
  setEndDate: (date: string) => void;
}

export const useGetEndDate = ({
  accountId,
  startDate,
  frequency,
  numberOfInstallments,
  installmentSize,
  setEndDate,
}: UseGetEndDateProps) => {
  const endDateForNonLinearPlan = useGetEndDateForNonLinearPlan();

  const fetchEndDate = useCallback(async () => {
    const newEndDate = await endDateForNonLinearPlan.mutateAsync({
      accountId,
      startDate: dayjs(startDate).format(DATE_FORMAT),
      frequency,
      numberOfInstallments,
      installmentSize: divide(installmentSize, 100),
      totalAmount: Math.floor(multiply(installmentSize, numberOfInstallments)),
    });
    setEndDate(dayjs(newEndDate).format(DATE_FORMAT));
  }, [accountId, startDate, frequency, numberOfInstallments, installmentSize, endDateForNonLinearPlan]);

  return {fetchEndDate};
};
